/* eslint-disable no-nested-ternary */
import React, { useState, useEffect, Fragment, useMemo } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import {
  Table, Tooltip, Select, Popconfirm, Dropdown, Checkbox, Tag, Radio, Space, Popover, Drawer,
  Divider,
} from 'antd';
import { ControlOutlined, FilterOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import { faAnglesRight, faDownload } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PurchaseOrderActions from '@Actions/purchaseOrderActions';
import GRNActions from '@Actions/grnActions';
import ZohoIntegrationActions from '@Actions/integrations/zohoIntegrationActions';
import TallyIntegrationActions from '@Actions/integrations/tallyIntegrationActions';
import CFV2Actions from '@Actions/configurations/cfV2Actions';
import H3Text from '@Uilib/h3Text';
import Helpers from '@Apis/helpers';
import H3Image from '@Uilib/h3Image';
import { toISTDate } from '@Apis/constants';
import TenantSelector from '@Components/Common/Selector/TenantSelector';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import ViewTableCustomFields from '@Components/Common/CustomField/ViewTableCustomFields';
import H3DateSelector from '@Uilib/h3DateSelector';
import ZohoBooks from '@Images/admin/integrations/zoho-books.png';
import TallyPrime from '@Images/admin/integrations/tally-prime.png';
import searchIcon from '@Images/icons/icon-search.png';
import Ai from '@Images/ai.png';
import Busy from '@Images/admin/integrations/busy.png';
import TagSelector from '@Components/Common/Selector/TagSelector';
import closeIcon from '@Images/icons/icon-close-blue.png';
import SelectDepartment from '@Components/Common/SelectDepartment';
import BusyIntegrationActions from '../../../../actions/integrations/busyIntegrationAction';
import OCRFileUploader from '../../../Common/OCRFileUploader';
import HideValue from '../../../Common/RestrictedAccess/HideValue';
import PRZText from '../../../Common/UI/PRZText';
import MoreInfoMobileView from '../../../Common/MoreInfoMobileView';
import { ListScreenKeys } from './ViewSTGRN/mobileListHelper';
import PRZSelect from '../../../Common/UI/PRZSelect';
import useCheckPortrait from '../../../../hooks/useCheckPortrait';
import { dateRangePresets, dateRangePresetsValues, entityNameEnum, filterTypeEnums } from '../../../../apis/constants';
import UserSavedFilterViewSelector from '../../../Common/UserSavedFilterViewSelector';
import './style.scss';

const { Option } = Select;

/**
 *
 */
function GRNList({
  grnData, getGRNLoading, getGRN, user, syncGRNLoading, history, getGRNSuccess, syncGRN, syncTallyGRN, syncTallyGRNLoading, getDocCFV2Loading, customFieldsProps, getDocCFV2, getDocCFV2Success, getDownloadGRNLoading, downloadGRNData, MONEY, pushGrnToBusy, pushGrnToBusyLoading,
  departments, priceMasking,
}) {
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [keyword, setKeyword] = useState('');
  const [searchKeyword, setSearchKeyword] = useState('');
  const [selectedTenant, setSelectedTenant] = useState('');
  // const [selectedTenantIds, setSelectedTenantIds] = useState('');
  const [isUserReady, setIsUserReady] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState('');
  const [sourceOfGrn, setSourceOfGrn] = useState([]);
  const [paymentStatus, setPaymentStatus] = useState([]);
  const [selectedEmails, setSelectedEmails] = useState('');
  const [openPopover, setOpenPopover] = useState(false);
  const [reportType, setReportType] = useState('document_level');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [grnFromDueDate, setGrnFromDueDate] = useState('');
  const [grnToDueDate, setGrnToDueDate] = useState('');
  const [fixedColumns, setFixedColumns] = useState(['GRN_NUMBER', 'VENDOR', 'LOCATION']);
  const [scheduleGrn, setScheduleGrn] = useState('');
  const [selectedTag, setSelectedTag] = useState([]);
  const [showFilters, setShowFilters] = useState(false);
  const [selectedDepartment, setSelectedDepartment] = useState([]);
  const [showOCRGRNDrawer, setShowOCRGRNDrawer] = useState(false);
  const [selectedGRN, setSelectedGRN] = useState(null);
  const [moreDetailsDrawer, setMoreDetailsDrawer] = useState(false);

  const [currentDefaultView, setCurrentDefaultView] = useState({});
  const [currentlyAppliedFilters, setCurrentlyAppliedFilters] = useState([]);
  const [selectedFilterView, setSelectedFilterView] = useState({});
  const [isUserReadyInitial, setIsUserReadyInitial] = useState(false);
  const [isUpdateFilterSate, setIsUpdateFilterSate] = useState(true);
  const [savedFilterViews, setSavedFilterViews] = useState([]);
  const [savedFilterViewsLoading, setSavedFilterViewsLoading] = useState(false);

  const [orderDateSelectedIntervalDateRangeType, setOrderDateSelectedIntervalDateRangeType] = useState('');
  const [dueDateSelectedIntervalDateRangeType, setDueDateSelectedIntervalDateRangeType] = useState('');

  const {
    isMobile, isPortrait, isMobileAndPortrait, isMobileOrPortrait,
  } = useCheckPortrait();

  const [visibleColumns, setVisibleColumns] = useState(localStorage.getItem('prcz-page-columns-grn') ? JSON.parse(localStorage.getItem('prcz-page-columns-grn')) : {
    GRN_NUMBER: {
      label: 'GRN#',
      visible: true,
    },
    LOCATION: {
      label: 'Location',
      visible: true,
    },
    VENDOR: {
      label: 'Vendor',
      visible: true,
    },
    VENDOR_INVOICE: {
      label: 'Vendor Invoice',
      visible: true,
    },
    REFERENCE: {
      label: 'Reference#',
      visible: true,
    },
    AMOUNT_WITHOUT_TAX: {
      label: 'Amount (Without Tax)',
      visible: false,
    },
    TAXES: {
      label: 'Taxes',
      visible: false,
    },
    GRAND_TOTAL: {
      label: 'Total Amount',
      visible: true,
    },
    CREATED_TIME: {
      label: 'Created Date',
      visible: true,
    },
    GATE_DOCUMENT: {
      label: 'Gate Document',
      visible: true,
    },
    GRN_DATE: {
      label: 'GRN Date',
      visible: true,
    },
    TOTAL_DUE: {
      label: 'Due Amount',
      visible: true,
    },
    DUE_DATE: {
      label: 'Due Date',
      visible: true,
    },
    EWB_NUMBER: {
      label: 'EWB Number',
      visible: true,
    },
    ATTACHMENTS: {
      label: 'Attachments',
      visible: true,
    },
    STATUS: {
      label: 'Status',
      visible: true,
    },
    PAYMENT_STATUS: {
      label: 'Payment Status',
      visible: true,
    },
    BILLING_STATUS: {
      label: 'Billing Status',
      visible: true,
    },
    LABEL: {
      label: 'Label',
      visible: true,
    },
  });

  const colorArray = ['blue', 'red', 'geekblue', 'green', 'volcano', 'orange', 'cyan', 'purple', 'blue', 'red', 'geekblue', 'green', 'volcano', 'orange', 'cyan', 'purple'];

  const { isDataMaskingPolicyEnable, isHideCostPrice, isHideSellingPrice } = priceMasking;

  /**
  *
  * @return {[{width: string, title: string, render: (function(*, *): JSX.Element)},{width: string, title: string, render: (function(*, *))}]}
  */
  const getGRNColumns = () => {
    const grnColumnsList = [
      {
        title: '',
        render: (record) => {
          function showGrnType() {
            switch (record?.grn_entity_type) {
              case 'INVENTORY_TRANSFER':
                return 'Stock Transfer';
              case 'GOOD_RECEIVING_NOTE':
                return 'ADHOC';
              case 'PURCHASE_ORDER':
                return 'Purchase Order';
              default:
            }
          }
          return (
            <div className="mobile-list__card">
              <div className="mobile-list__card_header">
                <div className="mobile-list__card_header-left">
                  <PRZText className="mobile-list__card_item-number" text={`#${record?.grn_number ? record.grn_number : 'N/A'}`} />
                </div>
                <div className="mobile-list__card_header-right">
                  <PRZText
                    style={{ backgroundColor: Helpers.getStatusColor(record.status).color }}
                    text={Helpers.getStatusColor(record.status).text?.toProperCase()}
                    className="mobile-list__card__status"
                  />
                </div>
              </div>
              <div className="mobile-list__card_body">
                <div className="mobile-list__card_body-left">
                  <div className="mobile-list__card_item-name_wrapper">
                    <Link to={`/vendors/view/${record?.seller_info?.seller_id}`} target="_blank">
                      <PRZText
                        className="mobile-list__card_item-name"
                        text={(record && record.tenant_seller_info) ? `${record?.internal_slr_code ? `${record?.internal_slr_code} - ` : ''}${record.tenant_seller_info?.seller_name}`?.trim() : ''}
                      />
                    </Link>
                  </div>
                  <PRZText
                    text={`Location - ${record?.tenant_name} (${record?.department_name || 'N/A'})`}
                    className="mobile-list__card_item-details"
                  />
                  <PRZText
                    text={`GRN Date - ${toISTDate(record?.grn_date_time).format('DD/MM/YYYY')}`}
                    className="mobile-list__card_item-details"
                  />
                  <PRZText
                    text={`Due Date - ${toISTDate(record?.grn_due_date).format('DD/MM/YYYY')}`}
                    className="mobile-list__card_item-details"
                  />
                </div>
                <div className="mobile-list__card_body-right">
                  <Tooltip
                    color="white"
                    placement="top"
                    title={(
                      <PRZText className="mobile-list__card_item__tooltip_text-color" text="Grand Total" />
                    )}
                  >
                    <PRZText
                      text={(isDataMaskingPolicyEnable && isHideCostPrice) ? <HideValue showPopOver popOverMessage="You don't have access to view grand total" /> : MONEY((record.grn_grand_total || '0'), record?.currency_code)}
                    />
                  </Tooltip>
                  <Tooltip
                    color="white"
                    placement="top"
                    title={(
                      <PRZText className="mobile-list__card_item__tooltip_text-color" text="Total Due" />
                    )}
                  >
                    <PRZText
                      text={
                        (isDataMaskingPolicyEnable && isHideCostPrice) ? (
                          <HideValue showPopOver popOverMessage="You don't have access to view total due" />
                        ) : (
                          MONEY(
                            (
                              (record?.grn_grand_total || 0)
                              - (record?.total_payment_made || 0)
                              - (
                                record
                                  ? Helpers.getValueTotalInObject(record?.debit_note_info, 'document_db_total')
                                  : Helpers.getValueTotalInObject(record?.debit_note_info, 'db_total')
                              )
                            ),
                            record?.currency_code,
                          )
                        )
                      }
                    />
                  </Tooltip>
                </div>
              </div>
              <Divider className="mobile-list__card_divider" />
              <div className="mobile-list__card_footer">
                <div className="mobile-list__card_footer-left">
                  <Tooltip
                    title={(
                      <PRZText
                        className="mobile-list__card_item__tooltip_text-color mobile-list__card_item__category__tooltip"
                        text="GRN Type"
                      />
                    )}
                    color="white"
                  >
                    <div
                      className="qr__status"
                      style={{
                        backgroundColor: 'rgb(28, 123, 225)',
                        fontSize: '10px',
                        padding: '1px 6px',
                      }}
                    >
                      {`${showGrnType()}`}
                    </div>
                  </Tooltip>
                  <div className="mobile-list__card_footer__actions-button_wrapper">
                    {user?.user_tenants?.find((item) => item?.tenant_id === record?.tenant_id)?.zoho_branch_id && !record?.allow_grn_to_create_ap_invoice && (
                      <div className="card_footer__actions-button">
                        <Fragment>
                          {
                            ['GOOD_RECEIVING_NOTE', 'PURCHASE_ORDER'].includes(record.grn_entity_type) && record?.status === 'ISSUED' && user?.user_tenants?.find((item) => item?.tenant_id === record?.tenant_id)?.zoho_branch_idz && (
                              <div>
                                {(record?.zoho_bill_id)
                                  ? (
                                    <Tooltip
                                      title={toISTDate(record?.zoho_updated_at).format('DD/MM/YYYY hh:mm A')}
                                      overlayClassName="font-12"
                                      placement="topRight"
                                    >
                                      <a
                                        href={`https://books.zoho.in/app#/bills/${record?.zoho_bill_id}`}
                                        target="_blank"
                                        rel="noreferrer"
                                      >
                                        <div className="img-zoho__wrapper card_footer__actions-button_image__wrapper">
                                          <img
                                            style={{
                                              width: '18px',
                                              height: '18px',
                                            }}
                                            src={ZohoBooks}
                                            alt="Zoho"
                                            className="img-zoho card_footer__actions-button_image"
                                          />
                                          <div className="green-indicator" />
                                        </div>
                                      </a>
                                    </Tooltip>
                                  )
                                  : (
                                    <Popconfirm
                                      title={(record?.zoho_warning_message === null || record?.zoho_warning_message === '') ? 'This GRN is not synced with Zoho Books.' : `${record?.zoho_warning_message}`}
                                      onConfirm={() => {
                                        if (!syncGRNLoading) {
                                          syncGRN(
                                            { grn_id: record?.grn_id },
                                            () => getGRN(user?.tenant_info?.tenant_id, null, null, null, '', limit, currentPage, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, true),
                                          );
                                        }
                                      }}
                                      okText="Sync again"
                                      okButtonProps={{
                                        loading: syncGRNLoading,
                                      }}
                                      cancelText="Cancel"
                                    >
                                      <div className="img-zoho__wrapper card_footer__actions-button_image__wrapper">
                                        <img
                                          style={{
                                            width: '18px',
                                            height: '18px',
                                          }}
                                          src={ZohoBooks}
                                          alt="Zoho"
                                          className="img-zoho img-zoho__disabled card_footer__actions-button_image"
                                        />
                                        <div className="green-indicator red-indicator" />
                                      </div>
                                    </Popconfirm>
                                  )}
                              </div>
                            )
                          }
                        </Fragment>

                      </div>
                    )}
                    {user?.user_tenants?.find((item) => item?.tenant_id === record?.tenant_id)?.tally_configuration?.purchase_voucher_integration && !record?.allow_grn_to_create_ap_invoice && (
                      <div className="card_footer__actions-button">
                        <Fragment>
                          {record.grn_entity_type !== 'INVENTORY_TRANSFER' && record?.status === 'ISSUED' && user?.user_tenants?.find((item) => item?.tenant_id === record?.tenant_id)?.tally_company_name && (
                            <div>
                              {(record?.tally_updated_at)
                                ? (
                                  <Tooltip
                                    title={`Last updated at ${toISTDate(record?.tally_updated_at).format('DD/MM/YYYY hh:mm A')}`}
                                    overlayClassName="font-12"
                                    placement="topRight"
                                  >
                                    <div className="img-tally__wrapper card_footer__actions-button_image__wrapper">
                                      <img
                                        src={TallyPrime}
                                        alt="Tally"
                                        className="img-tally card_footer__actions-button_image"
                                      />
                                      <div className="green-indicator" />
                                    </div>
                                  </Tooltip>
                                )
                                : (
                                  <Popconfirm
                                    title={record?.tally_warning_message || 'This GRN is not synced with Tally.'}
                                    onConfirm={() => syncTallyGRN(
                                      { grn_id: record?.grn_id },
                                      () => getGRN(user?.tenant_info?.tenant_id, null, null, null, '', limit, currentPage, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, true),
                                    )}
                                    okText="Sync again"
                                    okButtonProps={{
                                      loading: syncTallyGRNLoading,
                                    }}
                                    cancelText="Cancel"
                                  >
                                    <div className="img-tally__wrapper card_footer__actions-button_image__wrapper">
                                      <img
                                        src={TallyPrime}
                                        alt="Tally"
                                        className="img-tally img-tally__disabled card_footer__actions-button_image"
                                      />
                                      <div className="green-indicator red-indicator" />
                                    </div>
                                  </Popconfirm>
                                )}
                            </div>
                          )}
                        </Fragment>

                      </div>
                    )}
                    {
                      record?.is_busy_connected && !record?.allow_grn_to_create_ap_invoice && (
                        <div className="card_footer__actions-button">
                          {['ISSUED'].includes(record.status) && (
                            <div>
                              {' '}
                              {(record?.busy_sync_at)
                                ? (
                                  <Tooltip
                                    title={`Last updated at ${toISTDate(record?.busy_sync_at).format('DD/MM/YYYY hh:mm A')}`}
                                    overlayClassName="font-12"
                                    placement="topRight"
                                  >
                                    <div className="img-tally__wrapper card_footer__actions-button_image__wrapper">
                                      <img
                                        src={Busy}
                                        alt="Tally"
                                        className="img-tally card_footer__actions-button_image"
                                      />
                                      <div className="green-indicator" />
                                    </div>
                                  </Tooltip>
                                )
                                : (
                                  <Popconfirm
                                    title={record?.busy_sync_error || 'This GRN is not synced with Busy.'}
                                    onConfirm={() => pushGrnToBusy(
                                      { grn_id: record?.grn_id },
                                      () => getGRN(user?.tenant_info?.tenant_id, null, null, null, '', limit, currentPage, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, true),
                                    )}
                                    okText="Sync again"
                                    okButtonProps={{
                                      loading: pushGrnToBusyLoading,
                                    }}
                                    cancelText="Cancel"
                                  >
                                    <div className="img-tally__wrapper card_footer__actions-button_image__wrapper">
                                      <img
                                        src={Busy}
                                        alt="Tally"
                                        className="img-tally card_footer__actions-button_image"
                                      />
                                      <div className="green-indicator red-indicator" />
                                    </div>
                                  </Popconfirm>
                                )}
                            </div>
                          )}
                        </div>
                      )
                    }
                  </div>
                </div>
                <div className="mobile-list__card_footer-right">
                  <PRZText
                    className="mobile-list__card__view-more_wrapper"
                    onClick={() => {
                      setSelectedGRN(record);
                      setMoreDetailsDrawer(true);
                    }}
                    text={(
                      <span className="mobile-list__card__view-more-text_wrapper">
                        <span className="mobile-list__card__view-more-text">More Info</span>
                        <FontAwesomeIcon
                          className="mobile-list__card__view-more-icon"
                          icon={faAnglesRight}
                        />
                      </span>
                    )}
                  />
                </div>
              </div>
            </div>
          );
        },
        // responsive: ['xs'],
        hidden: !isMobile,
      },
      {
        title: 'GRN #',
        render: (record) => {
          function getRatingColor(rating) {
            if (rating >= 3) {
              return 'green';
            } if (rating >= 2) {
              return 'yellow';
            }
            return 'red';
          }

          function showGrnType() {
            switch (record?.grn_entity_type) {
              case 'INVENTORY_TRANSFER':
                return 'Stock Transfer';
              case 'GOOD_RECEIVING_NOTE':
                return 'ADHOC';
              case 'PURCHASE_ORDER':
                return 'Purchase Order';
              default:
            }
          }

          return (
            <div className="min-width-50">
              <H3Text text={record?.grn_number} />
              <div
                className="qr__status"
                style={{
                  backgroundColor: 'rgb(28, 123, 225)',
                  fontSize: '10px',
                  padding: '1px 6px',
                }}
              >
                {`${showGrnType()}`}
              </div>
              {user?.tenant_info?.seller_rating_config?.is_active && record?.rating > 0 && (
                <div className={`rating-container-update ${getRatingColor(record?.rating)}`}>
                  <div className="rating-container-main">
                    <span className="rating-value">{record?.rating?.toFixed(1) || 1.1}</span>
                    <span className="rating-star">&#9733;</span>
                  </div>
                </div>
              )}
            </div>
          );
        },
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        fixed: 'left',
        className: !visibleColumns?.GRN_NUMBER?.visible ? 'display-none' : '',
      },
      {
        title: 'LOCATION',
        render: (record) => (
          <div className="min-width-70">
            <H3Text text={record?.tenant_name} />
            <H3Text text={record?.department_name} className="table-subscript" />
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.LOCATION.visible ? 'display-none' : '',
      },
      {
        title: 'VENDOR',
        dataIndex: 'tenant_seller_info',
        render: (text, record) => (
          <div className="min-width-70">
            {record?.seller_name ? (
              <div className="associated-entity">
                <Link to={`/vendors/view/${record?.seller_id}`} target="_blank">
                  {`${record?.internal_slr_code ? `${record?.internal_slr_code} - ` : ''}${record?.seller_name}`?.trim()}
                </Link>
              </div>
            ) : '-'}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.VENDOR?.visible ? 'display-none' : '',
      },
      {
        title: 'VENDOR INVOICE #',
        dataIndex: 'invoice_number',
        render: (text, record) => (
          <div
            style={{
              color: 'rgb(87, 90, 87)',
            }}
            className="min-width-100"
          >
            {record?.invoice_number || '-'}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.VENDOR_INVOICE?.visible ? 'display-none' : '',
      },
      {
        title: 'REFERENCE#',
        dataIndex: 'po_id',
        render: (text, record) => (
          <div className="associated-entity min-width-85">
            {record?.grn_entity_type === 'PURCHASE_ORDER' ? (
              (() => {
                const firstPos = record?.linked_pos?.[0];
                const remainingPos = record?.linked_pos?.slice(1) || [];
                const remainingCount = remainingPos.length;

                return firstPos ? (
                  <Tooltip
                    title={
                      remainingCount > 0 ? (
                        <div className="tally-locations-tooltip">
                          {remainingPos?.map((po, index) => (
                            <Link
                              to={`/approval?type=po&id=${po?.po_id}`}
                              target="_blank"
                              style={{
                                fontWeight: 600,
                                color: '#1890ff',
                                fontSize: '13px',
                                display: 'block',
                                marginBottom: '4px',
                              }}
                            >
                              {po?.po_number}
                            </Link>
                          ))}
                        </div>
                      ) : (
                        <div className="tally-locations-tooltip">No additional Pos</div>
                      )
                    }
                    placement="top"
                    overlayInnerStyle={{ background: 'white', color: 'black' }}
                  >
                    <span >
                      <Link to={`/approval?type=po&id=${firstPos.po_id}`} target="_blank">
                        {firstPos.po_number}
                      </Link>
                      <span
                        style={{
                          color: "gray"
                        }}
                      >
                        {remainingCount > 0 && ` +${remainingCount} more`}
                      </span>
                    </span>
                  </Tooltip>
                ) : (
                  <span>-</span>
                );
              })()
            ) : record?.stock_transfer_number ? (
              <Link to={`/inventory/stock-transfer/view/${record.grn_entity_id}`} target="_blank">
                {record?.stock_transfer_number}
              </Link>
            ) : (
              <span>-</span>
            )}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.REFERENCE?.visible ? 'display-none' : '',
      },
      {
        title: 'GATE DOCUMENT NUMBER',
        width: '200px',
        render: (record) => {
          const gateDocNumber = record?.ref_gate_document;

          const otherDocs = (
            <div>
              {
                gateDocNumber?.slice(2).map((document, i) => (
                  <div className="other-uom-stock" key={i}>
                    <div
                      onClick={() => window.open(`/logistic/gate-document/view/${document?.gate_document_id}`)}
                      style={{
                        cursor: 'pointer',
                      }}
                    >
                      {document?.gate_document_number}
                    </div>
                  </div>
                ))
              }
            </div>
          );
          return (
            <Popover
              placement="bottom"
              content={gateDocNumber?.length > 2 && otherDocs}
              trigger="hover"
              getPopupContainer={(triggerNode) => triggerNode.parentNode}
            >
              <div className="min-width-115">
                {gateDocNumber?.slice(0, 2)?.map((document) => (
                  <Link
                    to={`/logistic/gate-document/view/${document?.gate_document_id}`}
                    target="_blank"
                    key={document?.gate_document_id}
                  >
                    <div className="associated-entity">
                      {document?.gate_document_number}
                    </div>
                  </Link>
                ))}
                {document?.length > 2 && (
                  <H3Text
                    className="table-subscript-grey"
                    text={`and ${document.length - 2} more`}
                  />
                )}
              </div>
            </Popover>
          );
        },
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.GATE_DOCUMENT?.visible ? 'display-none' : '',
      },
      {
        title: 'CREATED TIME',
        render: (text, record) => (
          <div className="min-width-100">
            <div className="column-date">
              {toISTDate(record?.created_at).format('DD/MM/YYYY hh:mm A')}
            </div>
            <H3Text text={(record?.first_name ? `${record?.first_name} ${record?.last_name}` : 'Unknown')} className="table-subscript" />
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.CREATED_TIME?.visible ? 'display-none' : '',
      },
      {
        title: 'GRN DATE',
        render: (text, record) => (
          <div className="column-date min-width-70">
            {toISTDate(record?.grn_date_time).format('DD/MM/YYYY')}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.GRN_DATE?.visible ? 'display-none' : '',
      },
      {
        title: 'AMOUNT WITHOUT TAX',
        render: (text, record) => (
          <div className="min-width-150">
            {record?.allow_grn_to_create_ap_invoice ? '-' : (isDataMaskingPolicyEnable && isHideCostPrice) ? <HideValue showPopOver popOverMessage="You don't have access to view grand total" /> : MONEY((record?.grn_base_price), record?.currency_code)}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns.AMOUNT_WITHOUT_TAX.visible ? 'display-none' : '',
      },
      {
        title: 'TAXES',
        render: (text, record) => (
          <div className="min-width-50">
            {(record?.allow_grn_to_create_ap_invoice || record?.seller_type === "OVERSEAS") ? '-' : MONEY((record?.grn_gst), record?.currency_code)}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns.TAXES.visible ? 'display-none' : '',
      },
      {
        title: 'GRAND TOTAL',
        render: (text, record) => (
          <div className="min-width-100">
            {record?.allow_grn_to_create_ap_invoice ? '-' : (isDataMaskingPolicyEnable && isHideCostPrice) ? <HideValue showPopOver popOverMessage="You don't have access to view grand total" /> : MONEY((record?.grn_grand_total), record?.currency_code)}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.GRAND_TOTAL?.visible ? 'display-none' : '',
      },
      {
        title: 'STATUS',
        render: (item) => (<div className="qr__status min-width-70" style={{ backgroundColor: Helpers.getStatusColor(item.status).color }}>{Helpers.getStatusColor(item.status).text}</div>),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.STATUS?.visible ? 'display-none' : '',
      },
      {
        title: 'PAYMENT STATUS',
        render: (item) =>
          item?.allow_grn_to_create_ap_invoice ? (
            <div className="min-width-115">-</div>
          ) : (
            <div
              style={{
                color: Helpers.getStatusColor(item?.payment_status).color,
              }}
              className="min-width-115"
            >
              {Helpers.getStatusColor(item?.payment_status).text?.toUpperCase()}
            </div>
          ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.PAYMENT_STATUS?.visible ? 'display-none' : '',
      },
      {
        title: 'BILLING STATUS',
        render: (item) => (
          <div
            style={{
              color: Helpers.getStatusColor(item?.billing_status ?? 'NOT_PAID').color,
            }}
            className="min-width-115"
          >
            {Helpers.getStatusColor(item?.billing_status ?? 'NOT_PAID').text?.toUpperCase()}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.BILLING_STATUS?.visible ? 'display-none' : '',
      },
      {
        title: 'TOTAL DUE',
        render: (text, record) => (
          <div className="min-width-85">
            {record?.allow_grn_to_create_ap_invoice ? '-' : (isDataMaskingPolicyEnable && isHideCostPrice) ? <HideValue showPopOver popOverMessage="You don't have access to view total due" /> : MONEY(
              (
                (record?.grn_grand_total)
                - record?.total_payment_made
                - (record?.currency_code
                  ? Helpers.getValueTotalInObject(record?.debit_note_info, 'document_db_total')
                  : Helpers.getValueTotalInObject(record?.debit_note_info, 'db_total')
                )
              ),
              record?.currency_code,
            )}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.TOTAL_DUE?.visible ? 'display-none' : '',
      },
      {
        title: 'DUE DATE',
        render: (text, record) => (
          <div className="min-width-85">
            <div className="column-date">
              {record?.grn_due_date ? <H3Text text={dayjs(record?.grn_due_date).format('DD/MM/YYYY')} /> : '-'}
            </div>
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.DUE_DATE?.visible ? 'display-none' : '',
      },
      {
        title: 'EWB NUMBER',
        render: (text, record) => (
          <div className="min-width-85">
            {
              record?.e_way_bill?.length > 0 ? record?.e_way_bill?.map((item) => (
                <div>
                  <a href={item?.url} target="_blank" rel="noreferrer">{record?.e_way_bill_number}</a>
                </div>
              )) : <div>{record?.e_way_bill_number}</div>
            }
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.EWB_NUMBER?.visible ? 'display-none' : '',
      },
      {
        title: 'ATTACHMENTS',
        render: (text, record) => (
          <div className="min-width-100">
            {
              record?.attachments?.map((item, index) => (
                <div>
                  <a href={item?.url} target="_blank" rel="noreferrer">{`Link# ${index + 1}`}</a>
                </div>
              ))
            }
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.ATTACHMENTS?.visible ? 'display-none' : '',
      },
      {
        title: 'LABELS',
        render: (item) => (
          <div className="min-width-70">
            <div className="table-labels__list">
              <div>
                <Space size={[0, 8]} wrap>
                  {item?.tags?.map((tag, index) => (
                    <Tag
                      key={index}
                      color={colorArray[index]}
                    >
                      {tag}
                    </Tag>
                  ))}
                </Space>
              </div>
            </div>
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.LABEL?.visible ? 'display-none' : '',
      },
    ];
    if (customFieldsProps?.data?.document_custom_fields?.length) {
      const customs = customFieldsProps?.data?.document_custom_fields;
      customs?.filter((item) => item?.is_active)?.map((custom) => {
        grnColumnsList.push({
          title: custom.field_name?.toUpperCase(),
          render: (record) => (
            <div className={Helpers.setColumnMinimumWidth(custom?.field_name)}>
              <ViewTableCustomFields customField={record.custom_fields?.filter((subItem) => subItem.cf_id === custom.cf_id)?.[0]} />
            </div>
          ),
          responsive: ['sm', 'md', 'lg', 'xxl'],
          hidden: isMobile,
          className: !visibleColumns?.[custom.cf_id]?.visible ? 'display-none' : '',
        });
      });
    }
    grnColumnsList.push({
      title: '',
      key: 'action',
      className: 'list__actions-column',
      render: (text, record) => (
        <div className="list__actions">
          {user?.user_tenants?.find((item) => item?.tenant_id === record?.tenant_id)?.zoho_branch_id && !record?.allow_grn_to_create_ap_invoice && (
            <div className="list__actions-button">
              <Fragment>
                {
                  ['GOOD_RECEIVING_NOTE', 'PURCHASE_ORDER'].includes(record.grn_entity_type) && record?.status === 'ISSUED' && user?.user_tenants?.find((item) => item?.tenant_id === record?.tenant_id)?.zoho_branch_id && (
                    <div>
                      {(record?.zoho_bill_id)
                        ? (
                          <Tooltip
                            title={toISTDate(record?.zoho_updated_at).format('DD/MM/YYYY hh:mm A')}
                            overlayClassName="font-12"
                            placement="topRight"
                          >
                            <a
                              href={`https://books.zoho.in/app#/bills/${record?.zoho_bill_id}`}
                              target="_blank"
                              rel="noreferrer"
                            >
                              <div className="img-zoho__wrapper">
                                <img
                                  src={ZohoBooks}
                                  alt="Zoho"
                                  className="img-zoho"
                                />
                                <div className="green-indicator" />
                              </div>
                            </a>
                          </Tooltip>
                        )
                        : (
                          <Popconfirm
                            placement="topRight"
                            title={(record?.zoho_warning_message === null || record?.zoho_warning_message === '') ? 'This GRN is not synced with Zoho Books.' : `${record?.zoho_warning_message}`}
                            onConfirm={() => {
                              if (!syncGRNLoading) {
                                syncGRN(
                                  { grn_id: record?.grn_id },
                                  () => getGRN(user?.tenant_info?.tenant_id, null, null, null, '', limit, currentPage, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, true),
                                );
                              }
                            }}
                            okText="Sync again"
                            okButtonProps={{
                              loading: syncGRNLoading,
                            }}
                            cancelText="Cancel"
                          >
                            <div className="img-zoho__wrapper">
                              <img
                                src={ZohoBooks}
                                alt="Zoho"
                                className="img-zoho img-zoho__disabled"
                              />
                              <div className="green-indicator red-indicator" />
                            </div>
                          </Popconfirm>
                        )}
                    </div>
                  )
                }
              </Fragment>

            </div>
          )}
          {user?.user_tenants?.find((item) => item?.tenant_id === record?.tenant_id)?.tally_configuration?.purchase_voucher_integration && !record?.allow_grn_to_create_ap_invoice && (
            <div className="list__actions-button">
              <Fragment>
                {record.grn_entity_type !== 'INVENTORY_TRANSFER' && record?.status === 'ISSUED' && user?.user_tenants?.find((item) => item?.tenant_id === record?.tenant_id)?.tally_company_name && (
                  <div>
                    {(record?.tally_updated_at)
                      ? (
                        <Tooltip
                          title={`Last updated at ${toISTDate(record?.tally_updated_at).format('DD/MM/YYYY hh:mm A')}`}
                          overlayClassName="font-12"
                          placement="topRight"
                        >
                          <div className="img-tally__wrapper">
                            <img
                              src={TallyPrime}
                              alt="Tally"
                              className="img-tally"
                            />
                            <div className="green-indicator" />
                          </div>
                        </Tooltip>
                      )
                      : (
                        <Popconfirm
                          placement="topRight"
                          title={record?.tally_warning_message || 'This GRN is not synced with Tally.'}
                          onConfirm={() => syncTallyGRN(
                            { grn_id: record?.grn_id },
                            () => getGRN(user?.tenant_info?.tenant_id, null, null, null, '', limit, currentPage, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, true),
                          )}
                          okText="Sync again"
                          okButtonProps={{
                            loading: syncTallyGRNLoading,
                          }}
                          cancelText="Cancel"
                        >
                          <div className="img-tally__wrapper">
                            <img
                              src={TallyPrime}
                              alt="Tally"
                              className="img-tally img-tally__disabled"
                            />
                            <div className="green-indicator red-indicator" />
                          </div>
                        </Popconfirm>
                      )}
                  </div>
                )}
              </Fragment>

            </div>
          )}
          {
            record?.is_busy_connected && !record?.allow_grn_to_create_ap_invoice && (
              <div className="list__actions-button">
                {['ISSUED'].includes(record.status) && (
                  <div>
                    {' '}
                    {(record?.busy_sync_at)
                      ? (
                        <Tooltip
                          title={`Last updated at ${toISTDate(record?.busy_sync_at).format('DD/MM/YYYY hh:mm A')}`}
                          overlayClassName="font-12"
                          placement="topRight"
                        >
                          <div className="img-tally__wrapper">
                            <img
                              src={Busy}
                              alt="Tally"
                              className="img-tally"
                            />
                            <div className="green-indicator" />
                          </div>
                        </Tooltip>
                      )
                      : (
                        <Popconfirm
                          placement="topRight"
                          title={record?.busy_sync_error || 'This GRN is not synced with Busy.'}
                          onConfirm={() => pushGrnToBusy(
                            { grn_id: record?.grn_id },
                            () => getGRN(user?.tenant_info?.tenant_id, null, null, null, '', limit, currentPage, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, true),
                          )}
                          okText="Sync again"
                          okButtonProps={{
                            loading: pushGrnToBusyLoading,
                          }}
                          cancelText="Cancel"
                        >
                          <div className="img-tally__wrapper">
                            <img
                              src={Busy}
                              alt="Tally"
                              className="img-tally"
                            />
                            <div className="green-indicator red-indicator" />
                          </div>
                        </Popconfirm>
                      )}
                  </div>
                )}
              </div>
            )
          }
          {!isPortrait && (
            <Link to={record?.grn_entity_type === 'PURCHASE_ORDER' ? `/purchase/goods-receiving/view/${record?.grn_id}` : (record?.grn_entity_type === 'INVENTORY_TRANSFER' ? `/purchase/goods-receiving/view/${record?.grn_id}/type=st` : (record?.grn_entity_type === 'GOOD_RECEIVING_NOTE') ? `/purchase/goods-receiving/view/${record?.grn_id}` : '/')}>
              <div
                className="list__actions-button list__actions-button-dark"
              // onClick={() => {
              //       // eslint-disable-next-line no-unused-expressions, no-nested-ternary
              //       record?.grn_entity_type === 'PURCHASE_ORDER' ? `/purchase/goods-receiving/view/${record?.grn_id}` : (record?.grn_entity_type === 'INVENTORY_TRANSFER' ? `/purchase/goods-receiving/view/${record?.grn_id}/type=st` : '/');
              // }}
              >
                View
              </div>
            </Link>
          )}
        </div>
      ),
      fixed: 'right',
      responsive: ['sm', 'md', 'lg', 'xxl'],
      hidden: isMobile,
    });
    return grnColumnsList.filter((item) => !item.hidden);
  };

  const pushParamsToUrl = (page, limit, currentTenant, status, word, start, end, Schedule, paymentStatusValue, grnFromDueDates, grnToDueDates, tags, departmentIds, sourceOfGrnValue, orderDateSelectedIntervalDateRangeType, dueDateSelectedIntervalDateRangeType, selectedFilterView) => {
    let url = '';
    if (page) url += `?page=${page}`;
    if (limit) url += `&limit=${limit}`;
    if (currentTenant) url += `&tenant=${currentTenant}`;
    if (status) url += `&status=${status}`;
    if (word) url += `&keyword=${word}`;
    if (start) url += `&from_date=${dayjs(start).format('YYYY-MM-DD')}`;
    if (end) url += `&to_date=${dayjs(end).format('YYYY-MM-DD')}`;
    if (orderDateSelectedIntervalDateRangeType) url += `&order_date_type=${orderDateSelectedIntervalDateRangeType}`;
    if (paymentStatusValue) url += `&payment_status=${paymentStatusValue}`;
    if (sourceOfGrnValue) url += `&grn_entity_type=${sourceOfGrnValue}`;
    if (Schedule) url += `&schedule_grn=${Schedule}`;
    if (grnFromDueDates) url += `&from_grn_due_date=${dayjs(grnFromDueDates).format('YYYY-MM-DD')}`;
    if (grnToDueDates) url += `&to_grn_due_date=${dayjs(grnToDueDates).format('YYYY-MM-DD')}`;
    if (dueDateSelectedIntervalDateRangeType) url += `&due_date_type=${dueDateSelectedIntervalDateRangeType}`;
    if (tags) url += `&label=${tags}`;
    if (departmentIds) url += `&department_ids=${departmentIds.join(',')}`;
    if (selectedFilterView) url += `&filter_id=${selectedFilterView?.filter_id}`;
    history.push(url);
  };

  function getFilterValueByKey({ filtersArray, key, valueOnly = true }) {
    const selectedFilter = filtersArray.find((item) => item.filter_key === key) || null;
    return valueOnly ? selectedFilter?.filter_value : selectedFilter;
  }

  function getAppliedFiltersFromURL() {
    const appliedFiltersFromURL = [
      {
        filter_key: 'limit',
        filter_value: Number(Helpers.getValueFromUrl('limit') || limit),
        filter_type: filterTypeEnums.NUMBER,
      },
      {
        filter_key: 'tenant',
        filter_value: Helpers.getValueFromUrl('tenant')
          ? Helpers.getValueFromUrl('tenant').split(',').map((item) => Number(item))
          : [],
        filter_type: filterTypeEnums.ARRAY,
      },
      {
        filter_key: 'status',
        filter_value: Helpers.getValueFromUrl('status') || '',
        filter_type: filterTypeEnums.STRING,
      },
      {
        filter_key: 'keyword',
        filter_value: Helpers.getValueFromUrl('keyword') || '',
        filter_type: filterTypeEnums.STRING,
      },
      {
        filter_key: 'from_date',
        filter_value: Helpers.getValueFromUrl('from_date') ? Number(dayjs(Helpers.getValueFromUrl('from_date')).startOf('day')) : '',
        filter_type: filterTypeEnums.DATE_RANGE,
        date_range_type: Helpers.getValueFromUrl('order_date_type') || '',
      },
      {
        filter_key: 'to_date',
        filter_value: Helpers.getValueFromUrl('to_date') ? Number(dayjs(Helpers.getValueFromUrl('to_date')).endOf('day')) : '',
        filter_type: filterTypeEnums.DATE_RANGE,
        date_range_type: Helpers.getValueFromUrl('order_date_type') || '',
      },
      {
        filter_key: 'payment_status',
        filter_value: Helpers.getValueFromUrl('payment_status')
          ? Helpers.getValueFromUrl('payment_status').split(',')
          : [],
        filter_type: filterTypeEnums.ARRAY,
      },
      {
        filter_key: 'grn_entity_type',
        filter_value: Helpers.getValueFromUrl('grn_entity_type')
          ? Helpers.getValueFromUrl('grn_entity_type').split(',')
          : [],
        filter_type: filterTypeEnums.ARRAY,
      },
      {
        filter_key: 'schedule_grn',
        filter_value: Helpers.getValueFromUrl('schedule_grn') || '',
        filter_type: filterTypeEnums.STRING,
      },
      {
        filter_key: 'from_grn_due_date',
        filter_value: Helpers.getValueFromUrl('from_grn_due_date') ? Number(dayjs(Helpers.getValueFromUrl('from_grn_due_date')).startOf('day')) : '',
        filter_type: filterTypeEnums.DATE_RANGE,
        date_range_type: Helpers.getValueFromUrl('due_date_type') || '',
      },
      {
        filter_key: 'to_grn_due_date',
        filter_value: Helpers.getValueFromUrl('to_grn_due_date') ? Number(dayjs(Helpers.getValueFromUrl('to_grn_due_date')).endOf('day')) : '',
        filter_type: filterTypeEnums.DATE_RANGE,
        date_range_type: Helpers.getValueFromUrl('due_date_type') || '',
      },
      {
        filter_key: 'label',
        filter_value: Helpers.getValueFromUrl('label')
          ? Helpers.getValueFromUrl('label').split(',')
          : [],
        filter_type: filterTypeEnums.ARRAY,
      },
      {
        filter_key: 'department_ids',
        filter_value: Helpers.getValueFromUrl('department_ids')
          ? Helpers.getValueFromUrl('department_ids').split(',').map((item) => Number(item))
          : [],
        filter_type: filterTypeEnums.ARRAY,
      },
    ];
    return appliedFiltersFromURL;
  }

  const initialFilterValues = useMemo(() => [
    {
      filter_key: 'limit',
      filter_value: limit,
      filter_type: filterTypeEnums.NUMBER,
    },
    {
      filter_key: 'tenant',
      filter_value: [user?.tenant_info?.tenant_id],
      filter_type: filterTypeEnums.ARRAY,
    },
    {
      filter_key: 'status',
      filter_value: '',
      filter_type: filterTypeEnums.STRING,
    },
    {
      filter_key: 'keyword',
      filter_value: '',
      filter_type: filterTypeEnums.STRING,
    },
    {
      filter_key: 'from_date',
      filter_value: '',
      filter_type: filterTypeEnums.DATE_RANGE,
      date_range_type: '',
    },
    {
      filter_key: 'to_date',
      filter_value: '',
      filter_type: filterTypeEnums.DATE_RANGE,
      date_range_type: '',
    },
    {
      filter_key: 'payment_status',
      filter_value: [],
      filter_type: filterTypeEnums.ARRAY,
    },
    {
      filter_key: 'grn_entity_type',
      filter_value: [],
      filter_type: filterTypeEnums.ARRAY,
    },
    {
      filter_key: 'schedule_grn',
      filter_value: '',
      filter_type: filterTypeEnums.STRING,
    },
    {
      filter_key: 'from_grn_due_date',
      filter_value: '',
      filter_type: filterTypeEnums.DATE_RANGE,
      date_range_type: '',
    },
    {
      filter_key: 'to_grn_due_date',
      filter_value: '',
      filter_type: filterTypeEnums.DATE_RANGE,
      date_range_type: '',
    },
    {
      filter_key: 'label',
      filter_value: [],
      filter_type: filterTypeEnums.ARRAY,
    },
    {
      filter_key: 'department_ids',
      filter_value: [],
      filter_type: filterTypeEnums.ARRAY,
    },
  ], []);

  const systemDefaultUserView = useMemo(() => ({
    filter_id: 'system_default',
    filter_name: 'System Default View',
    entity_name: entityNameEnum.GOOD_RECEIVING_NOTE,
    filters: initialFilterValues,
    tenant_id: user?.tenant_info?.tenant_id,
    org_id: user?.user_org_id,
    user_id: user?.user_id,
    is_default: false,
    is_system_default: true,
  }), []);

  useEffect(() => {
    if (user?.tenant_info?.org_id) {
      // setCurrentPage(Number(Helpers.getValueFromUrl('page') || currentPage));
      // setLimit(Number(Helpers.getValueFromUrl('limit') || limit));
      // // setSelectedTenantIds((Helpers.getValueFromUrl('tenant')?.split(',')?.length > 1 ? 'All' : Number(Helpers.getValueFromUrl('tenant'))) || user?.tenant_info?.tenant_id);
      // setSelectedTenant(Helpers.getValueFromUrl('tenant') ? Helpers.getValueFromUrl('tenant')?.split(',')?.map((item) => (Number(item))) : [user?.tenant_info?.tenant_id]);
      // setSelectedDepartment(Helpers.getValueFromUrl('department_ids') ? Helpers.getValueFromUrl('department_ids')?.split(',')?.map((item) => (Number(item))) : []);
      // setSelectedStatus(Helpers.getValueFromUrl('status'));
      // setSearchKeyword(Helpers.getValueFromUrl('keyword'));
      // setKeyword(Helpers.getValueFromUrl('keyword'));
      // setSelectedEmails([user?.email]);
      // setStartDate((Helpers.getValueFromUrl('from_date')));
      // setEndDate((Helpers.getValueFromUrl('to_date')));
      // setScheduleGrn((Helpers.getValueFromUrl('schedule_grn')));
      // setGrnFromDueDate((Helpers.getValueFromUrl('from_grn_due_date')));
      // setGrnToDueDate((Helpers.getValueFromUrl('to_grn_due_date')));
      // setPaymentStatus(Helpers.getValueFromUrl('payment_status') ? Helpers.getValueFromUrl('payment_status').split(',') : []);
      // setSourceOfGrn(Helpers.getValueFromUrl('grn_entity_type') ? Helpers.getValueFromUrl('grn_entity_type').split(',') : []);
      // setIsUserReady(true);

      setSelectedFilterView(systemDefaultUserView);
    }
    return () => {
      getDocCFV2Success(null);
    };
  }, []);

  useEffect(() => {
    if (savedFilterViews && isUserReadyInitial) {
      const defaultUserView = savedFilterViews.find((item) => item.is_default);

      if (defaultUserView) {
        setCurrentDefaultView(defaultUserView);
      } else {
        setCurrentDefaultView(systemDefaultUserView);
      }

      const appliedFiltersFromURL = getAppliedFiltersFromURL();

      const selectedFilterViewFromURL = Helpers.getValueFromUrl('filter_id');

      let currentSelectedView;
      if (selectedFilterViewFromURL) {
        currentSelectedView = savedFilterViews.find((item) => String(item.filter_id) === String(selectedFilterViewFromURL));
        if (!currentSelectedView) {
          currentSelectedView = systemDefaultUserView;
        }
      } else {
        currentSelectedView = defaultUserView || systemDefaultUserView;
      }

      const filterValues = (isFromURL) => {
        const currentSelectedViewFilters = currentSelectedView.filters;

        const filterValue = initialFilterValues.map((item) => item.filter_key).reduce((acc, filterKey) => ({ ...acc, [filterKey]: getFilterValueByKey({ filtersArray: isFromURL ? appliedFiltersFromURL : currentSelectedViewFilters, key: filterKey }) }), {});

        const _orderDateRangeType = getFilterValueByKey({ filtersArray: isFromURL ? appliedFiltersFromURL : currentSelectedViewFilters, key: 'from_date', valueOnly: false }).date_range_type;

        let _orderStartDate = '';
        let _orderEndDate = '';

        if (_orderDateRangeType === '' || _orderDateRangeType === dateRangePresets.CUSTOM) {
          // No action needed for empty or custom date range type
        } else {
          const date = dateRangePresetsValues(_orderDateRangeType);
          const [start, end] = date;

          _orderStartDate = start;
          _orderEndDate = end;
          filterValue.from_date = _orderStartDate;
          filterValue.to_date = _orderEndDate;
        }

        filterValue.orderDateRangeType = _orderDateRangeType;

        const _dueDateRangeType = getFilterValueByKey({ filtersArray: isFromURL ? appliedFiltersFromURL : currentSelectedViewFilters, key: 'from_grn_due_date', valueOnly: false }).date_range_type;

        let _dueStartDate = '';
        let _dueEndDate = '';

        if (_dueDateRangeType === '' || _dueDateRangeType === dateRangePresets.CUSTOM) {
          // No action needed for empty or custom date range type
        } else {
          const date = dateRangePresetsValues(_dueDateRangeType);
          const [start, end] = date;

          _dueStartDate = start;
          _dueEndDate = end;
          filterValue.from_grn_due_date = _dueStartDate;
          filterValue.to_grn_due_date = _dueEndDate;
        }

        filterValue.dueDateRangeType = _dueDateRangeType;

        return filterValue;
      };

      const tempFilterValues = filterValues(selectedFilterViewFromURL);

      setSelectedFilterView(currentSelectedView);
      if (isUpdateFilterSate) {
        setCurrentlyAppliedFilters(appliedFiltersFromURL);

        setSelectedEmails([user?.email]);

        setCurrentPage(Number(Helpers.getValueFromUrl('page') || currentPage));
        setLimit(tempFilterValues.limit || limit);
        setSelectedTenant(tempFilterValues.tenant);
        setSelectedDepartment(tempFilterValues.department_ids);
        setSelectedStatus(tempFilterValues.status);
        setSearchKeyword(tempFilterValues.keyword);
        setKeyword(tempFilterValues.keyword);
        setStartDate(tempFilterValues.from_date);
        setEndDate(tempFilterValues.to_date);
        setOrderDateSelectedIntervalDateRangeType(tempFilterValues.orderDateRangeType);
        setScheduleGrn(tempFilterValues.schedule_grn);
        setGrnFromDueDate(tempFilterValues.from_grn_due_date);
        setGrnToDueDate(tempFilterValues.to_grn_due_date);
        setDueDateSelectedIntervalDateRangeType(tempFilterValues.dueDateRangeType);
        setPaymentStatus(tempFilterValues.payment_status);
        setSourceOfGrn(tempFilterValues.grn_entity_type);
        setSelectedTag(tempFilterValues.label);
      }

      if (!isUserReady) setIsUserReady(true);
      if (!isUpdateFilterSate) setIsUpdateFilterSate(true);
    }
  }, [savedFilterViews, isUserReadyInitial]);

  const addEmails = (value) => { setSelectedEmails(value); };
  const downloadHandler = () => {
    const visibleColumnKeys = Object.entries(visibleColumns)
      .filter(([key, value]) => value.visible)
      .map(([key]) => key.toLowerCase())
      .join(',');
    const numbersArray = [];
    const stringsArray = [];
    const emailsArray = selectedEmails;

    const dataList = visibleColumnKeys.split(',');
    dataList.forEach((item) => {
      if (!isNaN(item)) {
        numbersArray.push(Number(item));
      } else {
        stringsArray.push(item);
      }
    });

    const numbersString = numbersArray.join(',');
    const stringsString = stringsArray.join(',');
    const emailsString = emailsArray.join(',');
    const payload = {
      org_id: user?.tenant_info?.org_id,
      tenant_id: selectedTenant?.filter((item) => !isNaN(item))?.length > 0 ? selectedTenant?.join(',') : Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.SALES_ORDER, Helpers.permissionTypes.READ)?.join(','),
      search_keyword: Helpers.getValueFromUrl('keyword'),
      status: Helpers.getValueFromUrl('status'),
      columns: stringsString,
      custom_fields: numbersString,
      no_wait: true,
      emails: emailsString,
      type: 'send_email',
      level: reportType,
      from_grn_due_date: Helpers.getValueFromUrl('from_grn_due_date'),
      to_grn_due_date: Helpers.getValueFromUrl('to_grn_due_date'),
      payment_status: Helpers.getValueFromUrl('payment_status'),
      grn_entity_type: Helpers.getValueFromUrl('grn_entity_type'),
      from_grn_date_time: Helpers.getValueFromUrl('from_date'),
      to_grn_date_time: Helpers.getValueFromUrl('to_date'),
      user_id: user?.user_id,
    };
    if (!getDownloadGRNLoading) {
      downloadGRNData(payload, () => {
        setOpenPopover(false);
      });
    }
  };

  useEffect(() => {
    if (isUserReady) {
      pushParamsToUrl(currentPage, limit, selectedTenant, selectedStatus, searchKeyword, startDate, endDate, scheduleGrn, paymentStatus, grnFromDueDate, grnToDueDate, selectedTag, selectedDepartment, sourceOfGrn, orderDateSelectedIntervalDateRangeType, dueDateSelectedIntervalDateRangeType, selectedFilterView);
      setCurrentlyAppliedFilters(getAppliedFiltersFromURL());
      getGRNSuccess(null);
      const payload = {
        orgId: user?.tenant_info?.org_id,
        entityName: 'GOOD_RECEIVING_NOTES',
      };
      getDocCFV2(payload);
      getGRN(
        selectedTenant?.filter(
          (item) => !isNaN(item),
        )?.length > 0 ? selectedTenant?.join(',')
          : Helpers.getTenantEntityPermission(
            user?.user_tenants, Helpers.permissionEntities.GOOD_RECEIVING, Helpers.permissionTypes.READ,
          )?.join(','),

        null, null, null, Helpers.getValueFromUrl('status'), Helpers.getValueFromUrl('limit'),
        Helpers.getValueFromUrl('page'), null, null, Helpers.getValueFromUrl('keyword'), '',
        Helpers.getValueFromUrl('from_date'), Helpers.getValueFromUrl('to_date'),
        Helpers.getValueFromUrl('schedule_grn'), Helpers.getValueFromUrl('payment_status'),
        Helpers.getValueFromUrl('from_grn_due_date'), Helpers.getValueFromUrl('to_grn_due_date'),
        Helpers.getValueFromUrl('label'), Helpers.getValueFromUrl('department_ids'), Helpers.getValueFromUrl('grn_entity_type'), null, null, null, true
      );
    }
  }, [selectedStatus, selectedTenant, searchKeyword, currentPage, limit, isUserReady, startDate, endDate, scheduleGrn, paymentStatus, grnFromDueDate, grnToDueDate, selectedTag, selectedDepartment, sourceOfGrn, orderDateSelectedIntervalDateRangeType, dueDateSelectedIntervalDateRangeType,
    // selectedFilterView
  ]);

  useEffect(() => {
    if (customFieldsProps?.data?.document_custom_fields?.length) {
      const customFields = customFieldsProps?.data?.document_custom_fields;
      const columns = JSON.parse(JSON.stringify(visibleColumns));
      customFields?.filter((item) => item?.is_active)?.map((customField) => {
        columns[customField.cf_id] = {
          label: customField?.field_name,
          visible: JSON.parse(localStorage.getItem('prcz-page-columns-grn'))?.[customField.cf_id]?.visible || false,
        };
      });
      setVisibleColumns(columns);
    }
  }, [customFieldsProps]);

  const grnStatusOptions = [
    { key: '', value: '', label: 'All GRNs' },
    { key: 'DRAFT', value: 'DRAFT', label: 'Draft' },
    { key: 'ISSUED', value: 'ISSUED', label: 'Issued' },
    { key: 'VOID', value: 'VOID', label: 'Void' },
    { key: 'PENDING_FOR_QC', value: 'PENDING_FOR_QC', label: 'Pending For QC' }
  ];

  /**
   *
   * @param {*} status
   * @return
   */
  return (
    <Fragment>
      <Drawer
        open={moreDetailsDrawer}
        mask
        onClose={() => setMoreDetailsDrawer(false)}
        destroyOnClose
        rootClassName="mobile__more-details_wrapper"
      >
        <div className="custom-drawer__header-wrapper">
          <div
            className="custom-drawer__header"
          >
            <H3Text
              text={`${selectedGRN?.grn_number}`}
              className="custom-drawer__title"
            />
            <H3Image
              src={closeIcon}
              className="custom-drawer__close-icon"
              onClick={() => setMoreDetailsDrawer(false)}
            />
          </div>
        </div>
        <MoreInfoMobileView
          customFields={selectedGRN?.custom_fields}
          fields={ListScreenKeys({ documentData: selectedGRN, MONEY, priceMasking })}
        />
      </Drawer>
      <Drawer
        open={showFilters}
        onClose={() => setShowFilters(false)}
        showHeader
        width="360px"
        destroyOnClose
      >
        <div className="custom-drawer__header-wrapper">
          <div className="custom-drawer__header" style={{ width: '310px' }}>
            <H3Text text="Apply Filters" className="custom-drawer__title" />
            <H3Image src={closeIcon} className="custom-drawer__close-icon" onClick={() => setShowFilters(false)} />
          </div>
        </div>
        <div className="grn-filters__wrapper">
          <div className="filter__container">
            <div className="filter__title">Business Unit</div>
            <TenantSelector
              selectedTenant={selectedTenant}
              showSearch
              onChange={(value) => {
                setSelectedTenant(value);
              }}
              placeholder="Select Business Unit"
              inputClassName="orgInputContainer"
              isMultiple
              hideTitle
              includedTenants={Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.GOOD_RECEIVING, Helpers.permissionTypes.READ)}
            />
          </div>
          <div className="filter__container" style={{ marginTop: '-15px' }}>
            <div className="filter__title">Departments</div>
            <SelectDepartment
              title="Select Department"
              hideTitle
              selectedDepartment={selectedDepartment}
              noDropdownAlign
              onChange={(value) => {
                setSelectedDepartment(value);
              }}
              isMultiple
            />
          </div>
          <div className="filter__container" style={{ marginTop: '-5px' }}>
            <div className="filter__title">Status</div>
            <PRZSelect
              value={selectedStatus}
              onChange={(value) => {
                setSelectedStatus(value);
                setCurrentPage(1);
              }}
              placeholder="Filter by status.."
              options={grnStatusOptions}
            />
          </div>
          <div className="filter__container" style={{ marginTop: '-5px' }}>
            <div className="filter__title">Source</div>
            <PRZSelect
              value={sourceOfGrn}
              onChange={(value) => {
                setSourceOfGrn(value);
                setCurrentPage(1);
              }}
              mode="multiple"
              placeholder="Filter by status.."
            >
              <Option key="INVENTORY_TRANSFER" value="INVENTORY_TRANSFER">Stock Transfer</Option>
              <Option key="PURCHASE_ORDER " value="PURCHASE_ORDER">Purchase Order</Option>
              <Option key="GOOD_RECEIVING_NOTE " value="GOOD_RECEIVING_NOTE">Adhoc </Option>
            </PRZSelect>
          </div>
          <div
            className="filter__container"
            style={{ marginTop: '-10px' }}
          >
            <div className="filter__title">Payment Status</div>
            <PRZSelect
              dropdownAlign={{ offset: [3, 4] }}
              value={paymentStatus}
              onChange={(value) => {
                setPaymentStatus(value);
                setCurrentPage(1);
              }}
              placeholder="Search by Payment Status.."
              className="purchase-orders__table-header__filter"
              mode="multiple"
            >
              <Option key="PAID_MORE" value="PAID_MORE">Paid More</Option>
              <Option key="PARTIALLY_PAID" value="PARTIALLY_PAID">Partially Paid</Option>
              <Option key="PAID" value="PAID">Paid</Option>
              <Option key="NOT_PAID" value="NOT_PAID">Not Paid</Option>
            </PRZSelect>
          </div>
          <div
            className="filter__container"
            style={{ marginTop: '-10px' }}
          >
            <div className="filter__title">GRN Due Date</div>
            <H3DateSelector
              selectedInterval={dueDateSelectedIntervalDateRangeType}
              startDate={grnFromDueDate}
              endDate={grnToDueDate}
              onDateChangeWithDateRangeType={({ date, dateRangeType }) => {
                setGrnFromDueDate(dayjs(date[0])?.startOf('day').valueOf());
                setGrnToDueDate(dayjs(date[1])?.endOf('day').valueOf());
                setCurrentPage(1);
                setDueDateSelectedIntervalDateRangeType(dateRangeType);
              }}
            />
          </div>
          <div className="filter__container">
            <div className="filter__title"> Select Labels </div>
            <div>
              <TagSelector
                filter
                entityType="GRN"
                selectedTags={selectedTag}
                showSearch
                showAll={false}
                noDropdownAlign
                isMultiple
                onChange={(value) => {
                  setCurrentPage(1);
                  setSelectedTag(value);
                }}
                placeholder="Select Label"
                inputClassName="orgInputContainer"
                hideTitle
                hideCSS
              />
            </div>
          </div>
        </div>
      </Drawer>
      <Drawer
        onClose={() => setShowOCRGRNDrawer(false)}
        open={showOCRGRNDrawer}
        width="800"
        destroyOnClose
      >
        <div className="custom-drawer__header-wrapper">
          <div className="custom-drawer__header" style={{ width: '750px' }}>
            <H3Text text="Create goods receiving note with automatic document scanning" className="custom-drawer__title" />
            <H3Image src={closeIcon} className="custom-drawer__close-icon" onClick={() => setShowOCRGRNDrawer(false)} />
          </div>
          <div style={{ paddingTop: '60px' }}>
            <OCRFileUploader
              entityName="invoice"
            />
          </div>
        </div>
      </Drawer>
      <div className="doc-list__wrapper">
        <div className="ant-row">
          <div className="ant-col-md-24 ant-col-xs-24">
            <div className="doc-list__header-wrapper">
              <div className="doc-list__header-wrapper__left">
                <div className="section-search">
                  <div className="doc-list__search-bar__wrapper">
                    <div className="section-search-bar">
                      <input
                        value={keyword}
                        placeholder="Search for Goods Receiving Note..."
                        onKeyDown={(e) => {
                          if (e.key === 'Enter') {
                            setSearchKeyword(e.target.value);
                            setCurrentPage(1);
                          }
                        }}
                        onChange={(event) => {
                          setKeyword(event.target.value);
                        }}
                      />
                      <H3Image
                        src={searchIcon}
                        className="section-search-bar__icon"
                        alt="search"
                        onClick={() => {
                          setSearchKeyword(keyword);
                          setCurrentPage(1);
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="doc-list__header-wrapper__right">
                {Helpers.getPermission(Helpers.permissionEntities.GOOD_RECEIVING,
                  Helpers.permissionTypes.CREATE, user) && (
                    <div className="doc-list__buttons-wrapper">
                      <H3Button
                        buttonType={defaultButtonTypes.BLUE_ROUNDED}
                        text="+ New GRN"
                        onClick={() => {
                          history.push('/purchase/goods-receiving/create');
                        }}
                        customClass="add-button"
                      />
                      <H3Button
                        buttonType={defaultButtonTypes.BLUE_ROUNDED}
                        text={(
                          <React.Fragment>
                            <img className="ai-icon-for-ocr" style={{ filter: 'none' }} src={Ai} alt="premium" />
                            {' '}
                            Auto Scan
                          </React.Fragment>
                        )}
                        onClick={() => {
                          setShowOCRGRNDrawer(true);
                        }}
                        customClass="ocr-button"
                      />
                    </div>
                  )}
              </div>
            </div>
          </div>
          <div className="flex-align-c" style={{ gap: '10px' }}>
            <UserSavedFilterViewSelector
              selectedFilterView={selectedFilterView}
              onChangeTab={(currentSelectedView) => {
                setSelectedFilterView(() => {
                  const currentSelectedViewFilters = currentSelectedView.filters;

                  const filterValue = initialFilterValues.map((item) => item.filter_key).reduce((acc, filterKey) => ({ ...acc, [filterKey]: getFilterValueByKey({ filtersArray: currentSelectedViewFilters, key: filterKey }) }), {});
                  const _orderDateRangeType = getFilterValueByKey({ filtersArray: currentSelectedViewFilters, key: 'from_date', valueOnly: false }).date_range_type;

                  let _orderStartDate = '';
                  let _orderEndDate = '';

                  if (_orderDateRangeType === '' || _orderDateRangeType === dateRangePresets.CUSTOM) {
                    // No action needed for empty or custom date range type
                  } else {
                    const date = dateRangePresetsValues(_orderDateRangeType);
                    const [start, end] = date;

                    _orderStartDate = start;
                    _orderEndDate = end;
                    filterValue.from_date = _orderStartDate;
                    filterValue.to_date = _orderEndDate;
                  }

                  filterValue.orderDateRangeType = _orderDateRangeType;

                  const _dueDateRangeType = getFilterValueByKey({ filtersArray: currentSelectedViewFilters, key: 'from_grn_due_date', valueOnly: false }).date_range_type;

                  let _dueStartDate = '';
                  let _dueEndDate = '';

                  if (_dueDateRangeType === '' || _dueDateRangeType === dateRangePresets.CUSTOM) {
                    // No action needed for empty or custom date range type
                  } else {
                    const date = dateRangePresetsValues(_dueDateRangeType);
                    const [start, end] = date;

                    _dueStartDate = start;
                    _dueEndDate = end;
                    filterValue.from_grn_due_date = _dueStartDate;
                    filterValue.to_grn_due_date = _dueEndDate;
                  }

                  filterValue.dueDateRangeType = _dueDateRangeType;

                  const tempFilterValues = filterValue;
                  setCurrentPage(1);
                  setCurrentPage(Number(Helpers.getValueFromUrl('page') || currentPage));
                  setLimit(tempFilterValues.limit || limit);
                  setSelectedTenant(tempFilterValues.tenant);
                  setSelectedDepartment(tempFilterValues.department_ids);
                  setSelectedStatus(tempFilterValues.status);
                  setSearchKeyword(tempFilterValues.keyword);
                  setKeyword(tempFilterValues.keyword);
                  setStartDate(tempFilterValues.from_date);
                  setEndDate(tempFilterValues.to_date);
                  setOrderDateSelectedIntervalDateRangeType(tempFilterValues.orderDateRangeType);
                  setScheduleGrn(tempFilterValues.schedule_grn);
                  setGrnFromDueDate(tempFilterValues.from_grn_due_date);
                  setGrnToDueDate(tempFilterValues.to_grn_due_date);
                  setDueDateSelectedIntervalDateRangeType(tempFilterValues.dueDateRangeType);
                  setPaymentStatus(tempFilterValues.payment_status);
                  setSourceOfGrn(tempFilterValues.grn_entity_type);
                  setSelectedTag(tempFilterValues.label);

                  return currentSelectedView;
                });
              }}
              currentlyAppliedFilters={currentlyAppliedFilters}
              entityName={entityNameEnum.GOOD_RECEIVING_NOTE}
              setSavedFilterViews={(value) => setSavedFilterViews(value)}
              setSavedFilterViewsLoading={(value) => setSavedFilterViewsLoading(value)}
              setIsUpdateFilterSate={(value) => setIsUpdateFilterSate(value)}
              callback={() => {
                if (!isUserReadyInitial) setIsUserReadyInitial(true);
              }}
              systemDefaultUserView={systemDefaultUserView}
            />
            <div className="header__tags">
              {searchKeyword && (
                <Tag closable onClose={() => { setSearchKeyword(''); setKeyword(''); setCurrentPage(1); }} color="#2d7df7">
                  Search results for -
                  &nbsp;
                  <span><b><i>{searchKeyword}</i></b></span>
                </Tag>
              )}
              {
                (startDate && endDate) ? (
                  <Tag
                    closable
                    onClose={() => {
                      setStartDate(null);
                      setEndDate(null);
                      setOrderDateSelectedIntervalDateRangeType('');
                    }}
                    color="#2d7df7"
                  >
                    {' '}
                    From:
                    &nbsp;
                    <span><b>{dayjs(startDate).format('DD/MM/YYYY')}</b></span>
                    &nbsp;
                    To:
                    &nbsp;
                    <span><b>{dayjs(endDate).format('DD/MM/YYYY')}</b></span>
                  </Tag>
                ) : ''
              }
              {
                (grnFromDueDate && grnToDueDate) ? (
                  <Tag
                    closable
                    onClose={() => {
                      setGrnFromDueDate(null);
                      setGrnToDueDate(null);
                      setDueDateSelectedIntervalDateRangeType('');
                    }}
                    color="#2d7df7"
                  >
                    {' '}
                    From Due Date:
                    &nbsp;
                    <span><b>{dayjs(grnFromDueDate).format('DD/MM/YYYY')}</b></span>
                    &nbsp;
                    To Due Date:
                    &nbsp;
                    <span><b>{dayjs(grnToDueDate).format('DD/MM/YYYY')}</b></span>
                  </Tag>
                ) : ''
              }

              {selectedTenant && selectedTenant?.map((item) => (
                <Tag
                  key={item}
                  closable
                  onClose={() => {
                    setCurrentPage(1);
                    setSelectedTenant(selectedTenant.filter((tId) => tId !== item));
                  }}
                  color="#2d7df7"
                >
                  Business Unit -
                  &nbsp;
                  <span>
                    <b>{user?.user_tenants?.find((tenant) => tenant?.tenant_id == item)?.tenant_name?.toUpperCase()}</b>
                  </span>
                </Tag>
              ))}
              {selectedDepartment && selectedDepartment?.map((item) => (
                <Tag
                  key={item}
                  closable
                  onClose={() => {
                    setCurrentPage(1);
                    setSelectedDepartment(selectedDepartment.filter((tId) => tId !== item));
                  }}
                  color="#2d7df7"
                >
                  Department -
                  &nbsp;
                  <span>
                    <b>{departments?.data?.result?.departments?.find((department) => department?.department_id == item)?.alias_name?.toUpperCase()}</b>
                  </span>
                </Tag>
              ))}
              {paymentStatus && paymentStatus
                .filter((item) => item != null) // Filter out null and undefined values
                .map((item) => (
                  <Tag
                    key={item}
                    closable
                    onClose={() => {
                      setCurrentPage(1);
                      setPaymentStatus(paymentStatus.filter((tId) => tId !== item));
                    }}
                    color="#2d7df7"
                  >
                    Payment Status -
                    &nbsp;
                    <span>
                      <b>{String(item).split('_').join(' ').toUpperCase()}</b>
                    </span>
                  </Tag>
                ))}
              {sourceOfGrn && sourceOfGrn
                .filter((item) => item != null) // Filter out null and undefined values
                .map((item) => (
                  <Tag
                    key={item}
                    closable
                    onClose={() => {
                      setCurrentPage(1);
                      setSourceOfGrn(sourceOfGrn.filter((tId) => tId !== item));
                    }}
                    color="#2d7df7"
                  >
                    Source -
                    &nbsp;
                    <span>
                      <b>{String(item === 'INVENTORY_TRANSFER' ? 'Stock Transfer' : item === 'GOOD_RECEIVING_NOTE' ? 'ADHOC' : item).split('_').join(' ').toUpperCase()}</b>
                    </span>
                  </Tag>
                ))}
              {selectedStatus && (
                <Tag closable onClose={() => { setSelectedStatus(''); setCurrentPage(1); }} color="#2d7df7">
                  Status -
                  &nbsp;
                  <span><b>{selectedStatus?.split('_').join(' ').toUpperCase()}</b></span>
                </Tag>
              )}
              {selectedTag && selectedTag?.map((item, index) => (
                <Tag
                  key={index}
                  closable
                  onClose={() => {
                    setCurrentPage(1);
                    setSelectedTag(selectedTag?.filter((tId) => tId !== item));
                  }}
                  color="#2d7df7"
                >
                  Label -
                  &nbsp;
                  <span>
                    <b>{item?.toUpperCase()}</b>
                  </span>
                </Tag>
              ))}
            </div>
          </div>
          <div className="doc-list__table-wrapper">
            <Table
              title={() => (
                <div className="doc-list__table-header">
                  <div className="doc-list__table-header__left">
                    <H3Text text={`${grnData?.count || '0'} Goods Receiving Notes`} className="" />
                  </div>
                  <div className="doc-list__table-header__right">
                    <div className="doc-list__filter-buttons">
                      {
                        grnData && grnData?.count > 0
                        && (
                          <Popover
                            placement="bottom"
                            trigger="click"
                            title={<div className="download-btn-popover__title">Please provide your email address</div>}
                            open={openPopover}
                            onOpenChange={() => setOpenPopover(!openPopover)}
                            content={(
                              <React.Fragment>
                                <div>
                                  <PRZSelect
                                    getPopupContainer={(triggerNode) => triggerNode.parentNode}
                                    mode="tags"
                                    filterOption={false}
                                    value={selectedEmails}
                                    onChange={addEmails}
                                    disabled={getDownloadGRNLoading}
                                    maxTagCount="responsive"
                                    style={{
                                      width: '300px',
                                      height: 'auto !important',
                                    }}
                                  >
                                    {selectedEmails.length > 0 ? (
                                      selectedEmails.map((item) => (
                                        <Option key={item} value={item}>
                                          {item}
                                        </Option>
                                      ))
                                    ) : (
                                      <Option key={user?.email} value={user?.email}>
                                        {user?.email}
                                      </Option>
                                    )}

                                  </PRZSelect>
                                </div>
                                <div className="mg-top-10">
                                  <Radio.Group onChange={(event) => setReportType(event?.target?.value)} disabled={getDownloadGRNLoading} value={reportType}>
                                    <Space direction="vertical">
                                      <Radio key="1" value="document_level">Goods Receiving Data</Radio>
                                      <Radio key="2" value="line_level">Goods Receiving Items Data</Radio>
                                    </Space>
                                  </Radio.Group>

                                </div>
                                <div className="mg-top-10">
                                  <H3Button
                                    text="Send"
                                    buttonType={defaultButtonTypes.BLUE_ROUNDED}
                                    onClick={() => downloadHandler()}
                                    customClass="email-submit"
                                    isLoading={getDownloadGRNLoading}
                                    disabled={getDownloadGRNLoading}
                                  >
                                    Send

                                  </H3Button>
                                </div>

                              </React.Fragment>
                            )}
                          >
                            <div
                              className={`download-btn
                                ${getDownloadGRNLoading ? 'download-btn__disabled' : ''}
                              `}
                              onClick={() => {
                                setOpenPopover(true);
                              }}
                            >
                              <H3Text
                                text={(
                                  <FontAwesomeIcon icon={faDownload} />
                                )}
                                className="action-button"
                              />
                            </div>
                          </Popover>
                        )
                      }
                      <H3DateSelector
                        selectedInterval={orderDateSelectedIntervalDateRangeType}
                        startDate={startDate}
                        endDate={endDate}
                        onDateChangeWithDateRangeType={({ date, dateRangeType }) => {
                          setStartDate(dayjs(date[0])?.startOf('day').valueOf());
                          setEndDate(dayjs(date[1])?.endOf('day').valueOf());
                          setCurrentPage(1);
                          setOrderDateSelectedIntervalDateRangeType(dateRangeType);
                        }}
                      />
                      <div className="doc-list__action-buttons">
                        <div className="action-button" onClick={() => setShowFilters(!showFilters)}>
                          <H3Text text="Filters" className="action-button-text" />
                          <FilterOutlined />
                        </div>
                      </div>
                      <Dropdown
                        overlay={(
                          <div className="custom-columns__content">
                            <div className="custom-columns__content-section">
                              <H3Text text="Visible Columns" className="custom-columns__content-title" />
                              {
                                Object.keys(visibleColumns).filter((item) => visibleColumns[item]?.visible)?.map((key) => (
                                  <div key={key}>
                                    <Checkbox
                                      disabled={fixedColumns.includes(key)}
                                      checked={visibleColumns[key]?.visible}
                                      onChange={() => {
                                        const visibleColumnsCopy = JSON.parse(JSON.stringify(visibleColumns));
                                        visibleColumnsCopy[key].visible = !visibleColumns[key].visible;
                                        localStorage.setItem('prcz-page-columns-grn', JSON.stringify(visibleColumnsCopy));
                                        setVisibleColumns(visibleColumnsCopy);
                                      }}
                                    >
                                      {visibleColumns[key]?.label}
                                    </Checkbox>
                                  </div>
                                ))
                              }
                            </div>
                            {Object.keys(visibleColumns).filter((item) => !visibleColumns[item]?.visible)?.length ? (
                              <div className="custom-columns__content-section">
                                <H3Text text="Hidden Columns" className="custom-columns__content-title" />
                                {
                                  Object.keys(visibleColumns).filter((item) => !visibleColumns[item]?.visible)?.map((key) => (
                                    <div key={key}>
                                      <Checkbox
                                        disabled={fixedColumns.includes(key)}
                                        checked={visibleColumns[key]?.visible}
                                        onChange={() => {
                                          const visibleColumnsCopy = JSON.parse(JSON.stringify(visibleColumns));
                                          visibleColumnsCopy[key].visible = !visibleColumns[key].visible;
                                          localStorage.setItem('prcz-page-columns-grn', JSON.stringify(visibleColumnsCopy));
                                          setVisibleColumns(visibleColumnsCopy);
                                        }}
                                      >
                                        {visibleColumns[key]?.label}
                                      </Checkbox>
                                    </div>
                                  ))
                                }
                              </div>
                            ) : ''}
                          </div>
                        )}
                        trigger={['click']}
                        placement="bottomRight"
                      >
                        <div className="custom-columns__wrapper">
                          Customize Columns
                          <ControlOutlined />
                        </div>
                      </Dropdown>
                    </div>
                  </div>
                </div>
              )}
              bordered
              showHeader
              loading={getGRNLoading || syncGRNLoading || getDocCFV2Loading || savedFilterViewsLoading}
              size="small"
              columns={getGRNColumns()}
              dataSource={grnData?.grn || []}
              currentPage
              scroll={!isMobileOrPortrait && !!grnData?.grn?.length ? { x: 'max-content', y: 'calc(100dvh - 180px)' } : { x: 'max-content' }}
              sticky={!isMobileOrPortrait && !!grnData?.grn?.length}
              pagination={
                {
                  defaultCurrent: currentPage,
                  current: currentPage,
                  total: grnData ? grnData.count : 0,
                  pageSize: limit,
                  onChange: (page, pageSize) => {
                    setCurrentPage(page);
                    setLimit(pageSize);
                  },
                  position: ['bottomLeft'],
                  showTotal: (tot, range) => `${range[0]}-${range[1]} of ${tot} items`,
                  showSizeChanger: true,
                  pageSizeOptions: [10, 25, 50, 100],
                }
              }
            />
          </div>
        </div>
      </div>
    </Fragment>
  );
}

const mapStateToProps = ({
  UserReducers, PurchaseOrderReducers, GRNReducers, CFV2Reducers, BusyIntegrationReducers, DepartmentReducers, ZohoIntegrationReducers,
}) => ({
  user: UserReducers.user,
  MONEY: UserReducers.MONEY,
  grnData: GRNReducers.grnData,
  getGRNLoading: GRNReducers.getGRNLoading,
  syncGRNLoading: ZohoIntegrationReducers.syncGRNLoading,
  selectedPurchaseOrder: PurchaseOrderReducers.selectedPurchaseOrder,
  getDocCFV2Loading: CFV2Reducers.getDocCFV2Loading,
  customFieldsProps: CFV2Reducers.cfV2DocGoodReceivingNotes,
  getDownloadGRNLoading: GRNReducers.getDownloadGRNLoading,
  pushGrnToBusyLoading: BusyIntegrationReducers.pushGrnToBusyLoading,
  departments: DepartmentReducers.departments,
  priceMasking: UserReducers.priceMasking,
});

const mapDispatchToProps = (dispatch) => ({
  downloadGRNData: (payload, callback) => dispatch(GRNActions.downloadGRNData(payload, callback)),
  getGRN: (tenantId, grnId, grnEntityId, grnEntityType, status, limit, page, tenantSellerId, selectedEntityType, searchKeyword, sellerId, startDate, endDate, scheduleGrn, paymentStatus, grnFromDueDate, grnToDueDate, tags, departmentIds, sourceOfGrn, callback, excludeGRNIds, excludeGRNVendorIds, is_list) => dispatch(
    GRNActions.getGRN(tenantId, grnId, grnEntityId, grnEntityType, status, limit, page, tenantSellerId, selectedEntityType, searchKeyword, sellerId, startDate, endDate, scheduleGrn, paymentStatus, grnFromDueDate, grnToDueDate, tags, departmentIds, sourceOfGrn, callback, excludeGRNIds, excludeGRNVendorIds, is_list),
  ),
  getGRNSuccess: (grnData) => dispatch(GRNActions.getGRNSuccess(grnData)),
  getPurchaseOrderById: (poId) => dispatch(PurchaseOrderActions.getPurchaseOrderById(poId)),
  getPurchaseOrderByIdSuccess: (selectedPurchaseOrder) => dispatch(PurchaseOrderActions.getPurchaseOrderByIdSuccess(selectedPurchaseOrder)),
  syncGRN: (payload, callback) => dispatch(ZohoIntegrationActions.syncGRN(payload, callback)),
  syncTallyGRN: (payload, callback) => dispatch(TallyIntegrationActions.syncTallyGRN(payload, callback)),
  getDocCFV2: (payload, callback) => dispatch(CFV2Actions.getDocCFV2(payload, callback)),
  getDocCFV2Success: (cf) => dispatch(CFV2Actions.getDocCFV2Success(cf)),
  pushGrnToBusy: (payload, callback) => dispatch(BusyIntegrationActions.pushGrnToBusy(payload, callback)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(GRNList));
